

export const frontMatter = {
	title: 'Request Website Status',
	draft: false,
	sidebar_label: 'Website Status',
	sidebar_position: 5,
	tags: [
		'code',
		'example',
		'website',
		'status'
	],
	keywords: [
		'code',
		'example',
		'website',
		'status'
	],
	description: 'Explore settings like call limits, currency information, and supported languages through a website status request. Learn with this API example.'
};
export const contentTitle = undefined;
export const metadata = {
  "id": "code-examples/javascript/website-status/index",
  "title": "Request Website Status",
  "description": "Explore settings like call limits, currency information, and supported languages through a website status request. Learn with this API example.",
  "source": "@site/docs/code-examples/javascript/website-status/index.mdx",
  "sourceDirName": "code-examples/javascript/website-status",
  "slug": "/code-examples/javascript/website-status/",
  "permalink": "/docs/code-examples/javascript/website-status/",
  "draft": false,
  "unlisted": false,
  "tags": [
    {
      "label": "code",
      "permalink": "/docs/tags/code"
    },
    {
      "label": "example",
      "permalink": "/docs/tags/example"
    },
    {
      "label": "website",
      "permalink": "/docs/tags/website"
    },
    {
      "label": "status",
      "permalink": "/docs/tags/status"
    }
  ],
  "version": "current",
  "lastUpdatedAt": 1748500809000,
  "sidebarPosition": 5,
  "frontMatter": {
    "title": "Request Website Status",
    "draft": false,
    "sidebar_label": "Website Status",
    "sidebar_position": 5,
    "tags": [
      "code",
      "example",
      "website",
      "status"
    ],
    "keywords": [
      "code",
      "example",
      "website",
      "status"
    ],
    "description": "Explore settings like call limits, currency information, and supported languages through a website status request. Learn with this API example."
  },
  "sidebar": "tutorialSidebar",
  "previous": {
    "title": "Contracts for Symbol",
    "permalink": "/docs/code-examples/javascript/contracts-for-symbol/"
  },
  "next": {
    "title": "Proposal",
    "permalink": "/docs/code-examples/javascript/proposal/"
  }
};
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import SandboxIframe from '@site/src/components/SandboxIframe';
import {sandboxes} from '@site/src/components/SandboxIframe/utility/sandboxes';
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Request the website status. From the API response you will be able to look into general settings like call limits, currencies information, supported languages and much more."
    }), "\n", _jsx(SandboxIframe, {
      sandbox: sandboxes.website_status
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

